define(['jquery', './ajax-link'], function ($, ajaxLink) {
  return ajaxLink.extend({
    ui: {
      container: '.js-load-more-container',
      button: '.js-load-more-button',
      buttonWrapper: '.js-load-more-button-wrapper',
      noActivityMessage: '.js-no-activity'
    },

    events: {
      'click @ui.button': 'loadMoreClicked'
    },

    loadMoreClicked: function (e) {
      e.preventDefault()
      e.stopPropagation()
      this.loadContent(this.ui.button)
    },

    options: {
      callBack: function (data) {
        if (!data.totalCount) {
          this.ui.noActivityMessage.removeClass('is-hidden')
          this.ui.buttonWrapper.addClass('is-hidden')
          return
        }

        var pagesTotal = Math.ceil((data.totalCount - 1) / 10)
        this.ui.container.append(data.payload)
        this.options.params.page += 1
        if (this.options.params.page > pagesTotal) {
          this.ui.buttonWrapper.addClass('is-hidden')
        }
        this.ui.button.blur()
      }
    },

    onRender: function () {
      this.loadContent(this.ui.button)
    }
  })
})
